import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

export async function getAvailabilityInfo(integrationId, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/availability-info`, language, timeZone, { integrationId }, cancelToken);
}

export async function addResourceGroup(language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/ResourceGroup/create`, language, timeZone, null, null, cancelToken);
}

export async function saveResourceGroup(group, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/ResourceGroup/save`, language, timeZone, group, null, cancelToken);
}

export async function addResource(resourceSplitId, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Resource/add`, language, timeZone, { resourceSplitId }, null, cancelToken);
}

export async function addResourceWithProduct(resourceSplitId, name, productId, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Resource/add`, language, timeZone, { resourceSplitId, name, productId }, null, cancelToken);
}

export async function saveResource(resource, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Resource/save`, language, timeZone, resource, null, cancelToken);
}

export async function reorderResources(resourceSplitId, orderedIds, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Resource/reorder`, language, timeZone, orderedIds, { resourceSplitId }, cancelToken);
}

export async function removeResource(id, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Resource/remove`, language, timeZone, { Id: id }, null, cancelToken);
}

export async function removeGroup(id, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/ResourceGroup/remove`, language, timeZone, { Id: id }, null, cancelToken);
}

export async function removeSplit(splitId, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/ResourceSplit/remove`, language, timeZone, { Id: splitId }, null, cancelToken);
}

export async function addSplit(resourceGroupId, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/ResourceSplit/add`, language, timeZone, { ResourceGroupId: resourceGroupId }, null, cancelToken);
}

// `resources` is `[{ name, productId }]`: the split is created with them already in it.
export async function addSplitWithResources(resourceGroupId, resources, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/ResourceSplit/add`, language, timeZone, {
    ResourceGroupId: resourceGroupId,
    Resources: resources.map(({ name, productId }) => ({ Name: name, ProductId: productId }))
  }, null, cancelToken);
}

export async function getResourceGroup(id, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/ResourceGroup/details`, language, timeZone, { id: id }, null, cancelToken);
}

export async function searchResourceGroups(
  options,
  language,
  timeZone,
  cancelToken
) {
  const { filters } = options;
  const {
    orderBy,
    orderDirection,
    id,
    page,
    facilityId,
    resultsPerPage
  } = filters;

  const params = {
    OrderBy: orderBy || "createdAt",
    OrderDirection: orderDirection || "desc",
    Page: page || 1,
    ResultsPerPage: resultsPerPage || 15,
    Id: id || undefined,
    FacilityId: facilityId || undefined
  };
  
  return await wsRequestPost(`/admin/ResourceGroup/search`, language, timeZone, params, null, cancelToken);
}

